import { defineNuxtPlugin } from "nuxt/app";
import userflow from "userflow.js";
import { useUserProfileStore } from "@/store/userProfileStore";

export default defineNuxtPlugin(() => {
  const userProfileStore = useUserProfileStore();
  let initialized = false;

  const initializeUserflow = () => {
    if (initialized || !userProfileStore.showUserflow) {
      return;
    }

    const userIdentifier = `${userProfileStore.firstName} ${userProfileStore.lastName} (${userProfileStore.customerId}-${userProfileStore.userId})`;

    userflow.init(userProfileStore.userflowKey as string);
    // the Help button in TheUserflow.vue replaces the default launcher
    userflow.setResourceCenterLauncherHidden(true);
    userflow.identify(userIdentifier, {
      userID: userProfileStore.userId,
      user_firstname: userProfileStore.firstName || "",
      user_lastname: userProfileStore.lastName || "",
      customerID: userProfileStore.customerId,
      url: window.location.origin,
      path: window.location.pathname
    });

    initialized = true;
  };

  return {
    provide: {
      initializeUserflow
    }
  };
});